// removed by extract-text-webpack-plugin
module.exports = {"advantages":"Advantages-m__advantages___91S7Z","items":"Advantages-m__items___2nrBU"};


//////////////////
// WEBPACK FOOTER
// ./components/advantages/Advantages.m.sass
// module id = afmg
// module chunks = 0